import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkMath from 'remark-math';
import rehypeKatex from 'rehype-katex';
import type { TableBlock } from '@/types/contentBlocks';

interface TableBlockProps {
  block: TableBlock;
  isDarkMode: boolean;
}

export const TableBlockRenderer: React.FC<TableBlockProps> = ({ block, isDarkMode }) => {
  return (
    <div
      className={`my-4 overflow-x-auto rounded-lg border max-w-[min-content] ${isDarkMode ? 'border-[#252525] bg-[#1e1e1e]' : 'border-border bg-card'
        } shadow-sm`}
    >
      <table className="min-w-max border-collapse">
        <thead className={isDarkMode ? 'bg-[#2d2d2d]' : 'bg-muted/50'}>
          <tr>
            {block.headers.map((header, idx) => (
              <th
                key={idx}
                className={`border-b border-r ${isDarkMode ? 'border-[#303030] bg-[#2d2d2d]' : 'border-border bg-muted'
                  } px-6 py-3 text-left text-sm font-semibold ${isDarkMode ? 'text-gray-300' : 'text-muted-foreground'
                  }`}
                style={{
                  textAlign: block.align?.[idx] || 'left',
                }}
              >
                <ReactMarkdown
                  remarkPlugins={[remarkGfm, remarkMath]}
                  rehypePlugins={[
                    [
                      rehypeKatex,
                      {
                        strict: false,
                        throwOnError: false,
                        trust: true,
                      },
                    ],
                  ]}
                >
                  {header}
                </ReactMarkdown>
              </th>
            ))}
          </tr>
        </thead>
        <tbody className={`divide-y ${isDarkMode ? 'divide-gray-700' : 'divide-border'}`}>
          {block.rows.map((row, rowIdx) => (
            <tr
              key={rowIdx}
              className={``}
            >
              {row.map((cell, cellIdx) => (
                <td
                  key={cellIdx}
                  className={`border-b border-r ${isDarkMode ? 'border-[#303030]' : 'border-border'
                    } px-6 py-4 text-sm ${isDarkMode ? 'text-gray-200' : 'text-card-foreground'}`}
                  style={{
                    textAlign: block.align?.[cellIdx] || 'left',
                  }}
                >
                  <ReactMarkdown
                    remarkPlugins={[remarkGfm, remarkMath]}
                    rehypePlugins={[
                      [
                        rehypeKatex,
                        {
                          strict: false,
                          throwOnError: false,
                          trust: true,
                        },
                      ],
                    ]}
                  >
                    {cell}
                  </ReactMarkdown>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
